import React, { useState, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { city } from '../../redux/actions/filterActions';
import { useHttp } from '../../hooks/httpHook';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import { isMobile } from "react-device-detect";
import arrowDown from '../../assets/arrowdown.SVG';

const useStyles = makeStyles({
    '@global': {
        '.MuiAutocomplete-option[data-focus="true"]': {
            background: '#3C70F1',
            color: '#fff'
        },
        '.MuiAutocomplete-popupIndicator': {
            marginRight: 0,
            transform: 'none',
            '&:hover': {
                backgroundColor: '#fff'
            },
        },

    },
    selectBorder: {
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#fff'
        },
    },
    paper: {
        marginLeft: isMobile ? 19 : 63,
        minWidth: isMobile ? 335 : 309,
        maxWidth: isMobile ? 335 : 309,
        marginTop: -10,
        border: '1px  solid #E3EFFE',
        borderTopRightRadius: 0,
        borderTopLeftRadius: 0,
        borderBottomRightRadius: 10,
        borderBottomLeftRadius: 10,
    },
    label: {
        color: '#16294680',
        fontSize: 16,
        fontWeight: 400,
        marginTop: 10,
    },
    imageIcon: {
        //position: 'absolute',
        // marginLeft: 275,
        marginRight: 10,
        pointerEvents: 'none',
    },
    clearIcon: {
        color: 'red',
        backgroundColor: 'red'
    }
});

const ArrowIcon = () => {
    const classes = useStyles();

    return (
        <img className={classes.imageIcon} src={arrowDown} />
    );
}



const City = ({ city }) => {
    const classes = useStyles();
    const [state, setState] = useState(null);
    const { request } = useHttp();
    const [classifier, setClassifier] = useState([]);
    const filterReducer = useSelector((state) => state.filterReducer);

    useEffect(() => {
        if (!filterReducer.city) {
            setState('');
        }
    }, [filterReducer.city]);

    const handleMenuItemClick = (option) => {
        setState(option ? option : null);
        city(option);
        localStorage.setItem('city', option && option.id ? option.id : '');
    };

    useEffect(() => {
        const getClassifier = async () => {
            let result = await request(`/cities `, 'get');
            let val;
            if (result && !result.error && result.data.length) {
                setClassifier(result.data);
                if (localStorage.getItem('city')) {
                    val = result.data.find(item => item.id.toString() === localStorage.getItem('city'));
                    setState(val);
                    city(val);
                }
            }
        };
        getClassifier();

    }, [request]);

    return (
        <Autocomplete
            className={classes.selectBorder}
            options={classifier}
            classes={{ paper: classes.paper }}
            value={state}
            disablePortal={true}
            ///clearIcon ={<AddCircleIcon fontSize="small" className={classes.clearIcon} />}
            popupIcon={<ArrowIcon disableRipple disableFocusRipple disableTouchRipple />}
            getOptionLabel={(option) => option.name}
            onChange={(e, newValue) => handleMenuItemClick(newValue)}
            renderInput={(params) =>
                <TextField {...params}
                    label="Город"
                    variant="outlined"
                    InputLabelProps={{
                        shrink: true,
                        classes: { root: classes.label }
                    }} />}

        />
    );
}

const mapStateToProps = state => ({
    city: state.city,
})

export default connect(mapStateToProps, { city, })(City)